<template>
    <CustomTable
        :column-form="column_form"
        :tab="true"
        :hideBtnTable="true"
        :hidePagi="true"
    >
        <template v-slot:header>
            <tr>
                <th rowspan="2">STT</th>
                <th rowspan="2">&nbsp;</th>
                <th rowspan="2">Trường</th>
                <th rowspan="2">Loại trường</th>
                <th rowspan="2">Lớp</th>
                <th rowspan="2">GV hiện có</th>
                <th rowspan="2">Định mức (giáo viên/lớp)</th>
                <th rowspan="2">GV cần có theo định mức</th>
                <th colspan="2">Giáo viên thừa thiếu</th>
            </tr>
            <tr>
                <th rowspan="1">Thừa</th>
                <th rowspan="1">Thiếu</th>
            </tr>
        </template>

        <template v-slot:body>
            <tr>
                <td>1</td>

                <td>55</td>
                <td>55</td>
                <td>55</td>
                <td>55</td>
                <td>55</td>
                <td>55</td>
                <td>55</td>
                <td>55</td>
                <td>55</td>
            </tr>
        </template>
    </CustomTable>
</template>

<script>
import CustomTable from '@/components/CustomTable.vue'

export default {
    name: 'TeacherSurplusShortageStatisticsByAllocation',
    components: {
        CustomTable
    },
    props: {
        statistical: { type: Number, require: true },
        column_form: { type: Number, require: true }
    },

    data() {
        return {
            tableData: []
        }
    },

    methods: {},
    mounted() {},

    computed: {}
}
</script>

<style scoped>
.min-width {
    min-width: 150px;
}
</style>
